export default function WhyWeCard({children, title}) {
    return <div
        className="bg-white p-6 rounded-xl shadow-md transition duration-300 hover:-translate-y-1 hover:shadow-lg">
        <h3 className="text-lg font-semibold text-[#0a2540] mb-3">
            {title}
        </h3>
        <p className="text-gray-700 text-sm leading-relaxed">
            {children}
        </p>
    </div>;
}